import { normalizeSiteLanguage } from '@yoyoclub/shared';

/**
 * Intl locale for dates and numbers in the current site language
 * (PRD §5.1): Traditional readers get zh-TW formatting, not zh-CN.
 */
export function dateLocale(lang: string | null | undefined): string {
  const site = normalizeSiteLanguage(lang);
  return site === 'en' ? 'en-US' : site;
}
